import * as React from 'react';
import {
  Button,
  Form,
  Input,
  Cascader,
  Select,
  AutoComplete,
  InputNumber,
  Radio,
  Checkbox,
  Rate,
  Slider,
  Switch,
  TimePicker,
  TreeSelect,
  DatePicker,
  Transfer,
  Upload,
  Space,
} from 'antd';
import RangeNumber from './CustomeElement/RangeNumber';
const TextArea = Input.TextArea;
const Search = Input.Search;
const Group = Input.Group;
const Password = Input.Password;
const TimeRangePicker = TimePicker.RangePicker;
const DateRangePicker = DatePicker.RangePicker;

const BlankElement = ({text}) => {
  return <span>{text}</span>
}

const compoents = {
  button: Button,
  text: Input,
  textarea: TextArea,
  search: Search,
  password: Password,
  cascader: Cascader,
  select: Select,
  autocomplete: AutoComplete,
  inputnumber: InputNumber,
  number: InputNumber,
  rate: Rate,
  slider: Slider,
  switch: Switch,
  timepicker: TimePicker,
  timerange: TimeRangePicker,
  datepicker: DatePicker,
  daterange: DateRangePicker,
  treeselect: TreeSelect,
  checkbox: Checkbox,
  checkboxgroup: Checkbox.Group,
  radio: Radio,
  radiogroup: Radio.Group,
  transfer: Transfer,
  upload: Upload,
  rangenumber: RangeNumber,
  blankelement: BlankElement
};

function inputComponent(Component, type, params) {
  if (type === 'button') {
    const { buttonType, ...restField } = params;
    return <Button {...restField} type={buttonType} />;
  }

  if (type === 'upload') {
    const { fieldName, ...restField } = params;
    return <Upload {...restField} name={fieldName} />;
  }

  if (type === 'inputnumber' || type === 'number') {
    const { controls = false, ...restField } = params;
    return <Component controls={controls} {...restField}/>;
  }

  if (type === 'checkboxgroup' || type === 'radiogroup') {
    const { direction, options, ...restField } = params;
    if (direction) {
      const ChildComponent = type === 'checkboxgroup' ? Checkbox : Radio;
      const opts = options.map(
        (item, ii) => {
          return (
            <ChildComponent
              key={`${type}-${item.value}-${ii}`}
              value={item.value}
            >
              {item.label}
              {item.children}
            </ChildComponent>
          );
        }
      );
      return (
        <Component {...restField}>
          <Space direction={direction}>{opts}</Space>
        </Component>
      );
    }
    return <Component {...restField} options={options} />;
  }

  return <Component {...params} />;
}

function generateInput(inputConfig) {
  if (React.isValidElement(inputConfig)) {
    return inputConfig;
  }
  const { type, ...restField } = inputConfig;
  if (type) {
    return inputComponent(compoents[type], type, restField);
  } else {
    console.warn('need define component type');
    return null;
  }
}

const eventsString = ['blur', 'focus'];
function isEventProperty(attribut) {
  const res = attribut.indexOf('on') === 0 ? true : false;
  return res ? res : eventsString.includes(attribut);
}

const InputUnitElement = (props) => {
  const form = Form.useFormInstance();
  const eventAttributs = [];
  let { unionEvnets, selfUnion, operate, ...restField } = props;
  const [opts, setOpts] = React.useState(
    restField.options || []
  );

  Object.keys(restField).forEach((ky) => {
    if (isEventProperty(ky)) {
      eventAttributs.push(ky);
    }
  });

  const util = {
    getForm() {
      return {
        ...form,
        setOptions(id, options) {
          operate.selectOp.setOptions(id, options);
        },
      };
    },
  };

  if (restField.type === 'select' || restField.type === 'cascader') {
    operate.selectOp.setAction(restField.id, setOpts);
    restField.options = opts;
  }

  const eventHandle = function (callback) {
    return function () {
      const args = arguments;
      callback.apply(this, [...args, util]);
    };
  };

  eventAttributs.forEach((evt) => {
    restField[evt] = eventHandle(restField[evt]);
  });

  return generateInput(restField);
};

export default InputUnitElement;